import Styles from '../styles.scss';

export const renderStyles = (idArray: string[]) =>
	idArray.length > 0
		? `${Styles.buzzBadgesSectionContainer} ${Styles.defaultMargins}`
		: `${Styles.buzzBadgesSectionContainer} ${Styles.buzzBadgesSectionContainerEmpty}`;
